import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from './../../redux/actions'
import autobind from 'react-autobind'
import { withRouter } from 'react-router-dom';
import _ from 'lodash'

import Header from './../../components/Header';
import Subheader from './../../components/Subheader';
import Footer from './../../components/Footer';
import Alert from './../../components/Errors/Alert';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

// import Switch from 'react-toggle-switch'
// import SubscriptionBox from './../../components/Subscription/SubscriptionBox'
import SubscriptionBoxList from './../../components/Subscription/SubscriptionBoxList'

class UpgradeSubscriptionPage extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            domainId: this.props.match.params.domain,
            type: this.props.match.params.type,
            domainName: '',
            subscriptions: [],
            activeSubscriptionId: null,
            currentSubscriptionId: null,
            recurrent: false,
            completeUpgradeModalOpen: false
        };
        autobind(this)
    }

    componentDidMount() {
        this.props.getSubscriptionsByDomain(this.state.domainId, () => {
            const { domainSubscriptions, userStatus } = this.props;

            _.forEach(userStatus.subscriptions, (subscription) => {
                if (subscription.domain._id === this.state.domainId) {
                    this.setState({
                        currentSubscriptionId: subscription.subscription._id,
                        domainName: subscription.domain.name
                    })
                }
            })

            this.setState({
                recurrent: false,
                subscriptions: domainSubscriptions
            })
        });
    }

    onChoosePlanClick(id) {

        this.setState({
            activeSubscriptionId: (this.state.activeSubscriptionId === id ? null : id)
        })

    }

    removeSelection() {

        this.setState({
            activeSubscriptionId: null
        })

    }

    onConfirmUpgrade() {

        if ('upgrade' === this.state.type) {
            this.props.upgradeSubscription(this.state.currentSubscriptionId, this.state.activeSubscriptionId, () => {
                this.setState({
                    completeUpgradeModalOpen: true
                })
            })
        } else if ('new' === this.state.type) {
            this.props.addSubscription(this.state.activeSubscriptionId, () => {
                this.setState({
                    completeUpgradeModalOpen: true
                })
            })
        }

    }

    finishUpgrade() {
        this.props.history.push('/my-account/');
    }

    render() {

        const { domainId, activeSubscriptionId, currentSubscriptionId, subscriptions, domainName } = this.state;
        const { error } = this.props
        return (
            <div>
                <Header />
                <Subheader breadcrumbs={[{ title: "My Account", link: "/my-account" }, `${domainName} Subscriptions`]} />
                <div className="main-content container">
                    <div className="row">
                        <div className="col">
                            <div className="d-flex justify-content-between mb-5" style={{ minHeight: 42 }}>
                                {this.state.type === 'upgrade' ? (<p>Please choose a subscription that you'll like to upgrade.</p>) : (<p>Please choose a new subscription.</p>)}

                                {/* {activeSubscriptionId ? <button className="btn btn-rounded btn-space btn-primary" onClick={this.onConfirmUpgrade}>Confirm selection</button> : ''} */}
                            </div>
                            {error ? <Alert message={error} /> : null}
                            <SubscriptionBoxList
                                key={domainId}
                                activeSubscriptionId={activeSubscriptionId}
                                currentSubscriptionId={currentSubscriptionId}
                                subscriptions={subscriptions}
                                removeSelection={this.removeSelection}
                                onConfirmUpgrade={this.onConfirmUpgrade}
                                onChoosePlanClick={this.onChoosePlanClick}
                                moduleName={domainName}
                                register={false}
                                collapsed={false}
                                showDisclaimer={true}
                                first={false} />
                        </div>
                    </div>
                </div >
                <Modal isOpen={this.state.completeUpgradeModalOpen} toggle={this.completeUpgradeModalOpen} className="modal-md">
                    <ModalHeader>
                        <span onClick={this.finishUpgrade} className="s7-close modal-close"></span>
                    </ModalHeader>
                    <ModalBody className="pt-0">
                        {this.state.type === 'upgrade' ? (<div><p>Your request to change the subscription plan has been sent.</p><p>You'll be contacted shortly about the payment.</p></div>) : (<p>Your subscription has been successfuly requested.</p>)}

                        <div className="d-flex justify-content-center">
                            <button className="btn btn-rounded btn-space btn-primary mt-5" onClick={this.finishUpgrade}>OK</button>
                        </div>
                    </ModalBody>
                </Modal>
                <Footer />
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const { subscriptionsByDomain: { domainSubscriptions, error }, userStatus } = state
        return { ...ownProps, domainSubscriptions, userStatus, error }
    },
    actions,
    (stateProps, dispatchProps) => {
        return Object.assign({}, stateProps, dispatchProps);
    }
)(withRouter(UpgradeSubscriptionPage))



// WEBPACK FOOTER //
// ./src/containers/Profile/UpgradeSubscription.js